module.exports = __webpack_public_path__ + "static/media/device_controls.301e0fc3.svg";